import AntDropdown from 'antd/lib/dropdown';

import 'antd/lib/dropdown/style/index.css';

export default AntDropdown;
